module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_86.4c6e0a9c.jpg";